<template>
  <v-dialog v-model="data.dialog" persistent max-width="600px">
    <v-card v-if="loading" :color="isDelete ? 'error' : 'info'" dark>
      <v-card-text>
        <span class="font-weight-bold text-white">{{ $t('loading') }}</span>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
    <v-card v-if="!loading">
      <v-card-title
        :class="{'form-danger': isDelete, 'form-info': isUpdate, 'form-primary': isCreate}"
      >
        <span v-if="isCreate" class="">{{ $('create') }}</span>
        <span v-if="isUpdate" class="">{{ $('update') }}</span>
        <span v-if="isDelete" class="">{{ $('delete') }}</span>
      </v-card-title>
      <v-card-text>
        <h2 v-if="isDelete && identifier" class="my-3">
          {{ $('delete_msg', [identifier.name]) }}
        </h2>

        <v-form
          v-if="!isDelete"
          ref="form"
          v-model="valid"
        >
          <v-container>
            <v-row>
              <v-col
                class="mt-2"
                cols="12"
              >
                <v-text-field
                  v-model="form.name"
                  v-max-length="200"
                  :label="$('name')"
                  required
                  outlined
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
              >
                <v-autocomplete
                  v-model="form.checkpoint_id"
                  :items="checkpoints"
                  item-text="name"
                  item-value="id"
                  clearable
                  :label="$('checkpoint')"
                  outlined
                >
                  <template v-slot:item="{item}">
                    {{ item.name | short_string(30) }}
                  </template>
                  <template v-slot:selection="{item}">
                    {{ item.name | short_string(30) }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="light"
          outlined
          @click="dialogModal(false)"
        >
          {{ $t('form.cancel') }}
        </v-btn>
        <v-btn
          v-if="isCreate"
          color="primary"
          :disabled="!valid || submitLoading"
          :loading="submitLoading"
          @click="submit"
        >
          {{ $t('form.create') }}
        </v-btn>
        <v-btn
          v-if="isUpdate"
          color="info"
          :disabled="!valid || submitLoading"
          :loading="submitLoading"
          @click="submit"
        >
          {{ $t('form.save') }}
        </v-btn>
        <v-btn
          v-if="isDelete"
          color="error"
          :disabled="submitLoading"
          :loading="submitLoading"
          @click="submit"
        >
          {{ $t('form.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '@axios'
import toast from '@/store/toast'

export default {
  name: 'DeviceDialog',
  props: {
    data: {
      type: Object,
      default: () => ({
        dialog: false,
        id: null,
        type: 'create',
      }),
    },
    dialogModal: {
      type: Function,
      default: state => {
        this.data.dialog = state
      },
    },
    translationKey: {
      type: String,
      default: () => '',
    },
  },
  emits: ['update:table'],
  setup() {
    return {
    }
  },
  data: () => ({
    loading: true,
    submitLoading: false,
    valid: false,
    checkpoints: [],
    identifier: null,
    form: {
      name: '',
      checkpoint_id: '',
    },

  }),
  computed: {
    isCreate() {
      return this.data.type === 'create'
    },
    isUpdate() {
      return this.data.type === 'update'
    },
    isDelete() {
      return this.data.type === 'delete'
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      async handler(val) {
        try {
          this.loading = true;
          if (val.id) {
            const devices = await axios.get(`/devices/${val.id}`);
            this.form = devices.data.data;
            this.identifier = devices.data.data
          }
          if (!val.dialog) {
            this.resetForm();
          }
        } catch (error) {
          // await toast.dispatch('error', error.response ? error.response.data.message : error.message)
        } finally {
          this.loading = false;
        }
      },
    },
  },
  async mounted() {
    const check = await axios.get('/checkpoints')
    this.checkpoints = check.data.data
  },
  methods: {
    async submit() {
      try {
        this.submitLoading = true;
        if (this.isDelete) {
          await axios.delete(`/devices/delete/${this.data.id}`);
          this.dialogModal(false)
          await toast.dispatch('success', this.$t('form.success.delete'))
          this.$emit('update:table')
        }
        if (this.$refs.form.validate() === false) {
          this.$emit('update:table')
        }
        if (this.isCreate) {
          if (this.$refs.form.validate() === true) {
            await axios.post('/devices/create', this.form);
            this.dialogModal(false)
            await toast.dispatch('success', this.$t('form.success.create'))
          }
        } else if (this.isUpdate) {
          await axios.post(`/devices/edit/${this.data.id}`, this.form);
          this.dialogModal(false)
          await toast.dispatch('success', this.$t('form.success.update'))
        }
        this.$emit('update:table')

        // this.dialogModal(false)
      } catch (error) {
        // await toast.dispatch('error', error.response ? error.response.data.message : error.message)
      } finally {
        this.submitLoading = false;
      }
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.form = {
        name: '',
        address: '',
        active: '',
        funerals: '',
      };
    },
    $(key, parameters = null) {
      return this.$t(`${this.translationKey}.modal.${key}`, parameters);
    },
  },
}
</script>

<style scoped>

</style>
